import { HomeBinary } from '../types/HomeBinary';
import { HomeDashboard } from '../types/HomeDashboard';
import { HomeExtra } from '../types/HomeExtra';
import { HomePackage } from '../types/HomePackage';
import { HomePromotion } from '../types/HomePromotion';
import { HomeRank } from '../types/HomeRank';
import { MailNotification } from '../types/MailNotification';
import { OrderNotification } from '../types/OrderNotification';
import { PayoutNotification } from '../types/PayoutNotification';
import { ApiService } from './apiService';

export class HomeService {
  private apiService = new ApiService();

  async getDashboardData(): Promise<HomeDashboard> {
    const response = await this.apiService.get('/api/home/dashboard');
    const json = response.data as Record<string, any>;
    return HomeDashboard.fromJson(json);
  }

  async getDashboardExtra(): Promise<HomeExtra> {
    const response = await this.apiService.get('/api/home/dashboard/extra');
    const json = response.data as Record<string, any>;
    return HomeExtra.fromJson(json);
  }

  async getRankData(): Promise<HomeRank> {
    const response = await this.apiService.get('/api/home/ranks');
    const json = response.data as Record<string, any>;
    return HomeRank.fromJson(json);
  }

  async getPackageData(): Promise<HomePackage> {
    const response = await this.apiService.get('/api/home/packages');
    const json = response.data as Record<string, any>;
    return HomePackage.fromJson(json);
  }

  async getPromotionData(): Promise<HomePromotion> {
    const response = await this.apiService.get('/api/home/promotions');
    const json = response.data as Record<string, any>;
    return HomePromotion.fromJson(json);
  }

  async getBinaryData(): Promise<HomeBinary> {
    const response = await this.apiService.get('/api/home/binary');
    const json = response.data as Record<string, any>;
    return HomeBinary.fromJson(json);
  }

  async getNotificationData(): Promise<{
    orders: OrderNotification[];
    payouts: PayoutNotification[];
    messages: MailNotification[];
  }> {
    const response = await this.apiService.get('/api/home/notifications');
    const json = response.data as Record<string, any>;

    return {
      orders: (json.orders as Array<Record<string, any>>).map((e) =>
        OrderNotification.fromJson(e)
      ),
      payouts: (json.payouts as Array<Record<string, any>>).map((e) =>
        PayoutNotification.fromJson(e)
      ),
      messages: (json.messages as Array<Record<string, any>>).map((e) =>
        MailNotification.fromJson(e)
      ),
    };
  }

  async getNotificationCount(): Promise<{
    orderCount: number;
    payoutCount: number;
    messageCount: number;
    totalCount: number;
  }> {
    const response = await this.apiService.get('/api/home/notifications_count');
    const json = response.data as Record<string, any>;

    return {
      orderCount: json.order_count as number,
      payoutCount: json.payout_count as number,
      messageCount: json.message_count as number,
      totalCount: json.total_count as number,
    };
  }
}
